import Trix from 'trix';

addHeadingAttributes();

addEventListener('trix-initialize', function (event) {
  new RichText(event.target);
});

class RichText {
  constructor(element) {
    this.element = element;
    this.insertHeadingElements();
  }

  insertHeadingElements() {
    this.removeOriginalHeadingButton();
    this.insertNewHeadingButtons();
  }

  removeOriginalHeadingButton() {
    this.buttonGroupBlockTools.removeChild(this.originalHeadingButton);
  }

  insertNewHeadingButtons() {
    this.buttonGroupBlockTools.insertAdjacentHTML(
      'afterbegin',
      this.headingButtonsTemplate
    );
  }

  get buttonGroupBlockTools() {
    return this.toolbarElement.querySelector('[data-trix-button-group=block-tools]');
  }

  get originalHeadingButton() {
    return this.toolbarElement.querySelector('[data-trix-attribute=heading1]');
  }

  get toolbarElement() {
    return this.element.toolbarElement;
  }

  get headingButtonsTemplate() {
    return '<button type="button" class="trix-button" data-trix-attribute="heading1" title="Heading 1" tabindex="-1">H1</button><button type="button" class="trix-button" data-trix-attribute="heading2" title="Heading 2" tabindex="-1">H2</button><button type="button" class="trix-button" data-trix-attribute="heading3" title="Heading 3" tabindex="-1">H3</button><button type="button" class="trix-button" data-trix-attribute="heading4" title="Heading 4" tabindex="-1">H4</button><button type="button" class="trix-button" data-trix-attribute="heading5" title="Heading 5" tabindex="-1">H5</button><button type="button" class="trix-button" data-trix-attribute="heading6" title="Heading 6" tabindex="-1">H6</button>';
  }
}

function addHeadingAttributes() {
  Array.from(['h1', 'h2', 'h3', 'h4', 'h5', 'h6']).forEach((tagName, i) => {
    Trix.config.blockAttributes[`heading${i + 1}`] = {
      tagName: tagName,
      terminal: true,
      breakOnReturn: true,
      group: false
    };
  });
}
